/** @file resetToRest: writes the rest values of some nodes at the playhead (one clip.setPose). */
import type { NodeKey } from '@zilo/pose3d-format/types/clip';
import type { EditorStore } from '../../state/editorTypes';
import { editTarget } from '../../panels/viewport/editTarget';
import { setPoseCommand } from '../../panels/viewport/setPoseCommand';

/** One `clip.setPose` on the playhead clip and frame; nothing (with the edit target's toast) without a usable target. */
export function resetToRest(store: EditorStore, nodes: string[]): void {
  const s = store.getState();
  const target = editTarget(s);
  if (target === null) return;
  const rest: Record<string, NodeKey> = Object.fromEntries(nodes.map((n) => [n, { rot: [0, 0, 0], pos: [0, 0, 0], scale: 1 } satisfies NodeKey]));
  void s.dispatch([setPoseCommand(target.clip, target.frame, rest)], 'Reset to rest');
}
